import React, { useEffect, useState, useContext } from 'react'
import {
  BrowserRouter as Router,
  Link,
  Navigate,
  useNavigate,
  useParams
} from "react-router-dom"
import { subscribe } from "../utils/pubsub"
import FormatQuestionAnswer from './FormatQuestionAnswer'
import Button from '../formfields/Button'
import SubNavigation from '../shared-components/SubNavigation'
import { GlobalContext } from '../GlobalContext'
import Card from '../ui-elements/Card'
import GreenAlert from '../ui-elements/GreenAlert'
import RedAlert from '../ui-elements/RedAlert'
import { getDate } from '../utils/getDate'
import { getDateFromMonthYearDay } from '../utils/getDateFromMonthYearDay'
import { getDaysInMonth } from '../utils/getDaysInMonth'
import { getStartAndEndTimestampsForDay } from '../utils/getStartAndEndTimestampsForDay'
import { getStartAndEndTimestampsForMonth } from '../utils/getStartAndEndTimestampsForMonth'
import Spinner from '../ui-elements/Spinner'
import FormatChecklistTimeWindow from './FormatChecklistTimeWindow'
import { sortChecklistDataByTimePeriod } from './checklist-utils/sortChecklistDataByTimePeriod'
import YellowAlert from '../ui-elements/YellowAlert'
import { start } from 'repl'
import FooterNavButtonFrame from '../ui-elements/FooterNavButtonFrame'
import JsonDebug from '../ui-elements/JsonDebug'

type Props = {
}

type ChecklistPeriodsProps = {
  thisCheckPeriod: ObjectStringKeyAnyValue
}




function ExportChecklistResults({
}: Props) {

  const {
    tableData,
    sendMessageToWebsocket,
    setShowModal
  } = useContext(GlobalContext)


  const navigate = useNavigate()
  const { checklistId } = useParams()
  const [formFields, setFormFields] = useState<ObjectStringKeyAnyValue>({})
  const [formErrors, setFormErrors] = useState<ObjectStringKeyAnyValue>({})

  const today = new Date().toISOString().split("T")[0];

  console.log(formFields)

  const validate = () => {
    let isValid = true
    const newFormErrors: ObjectStringKeyAnyValue = {}

    if (!formFields.startDate || !formFields.endDate) {
      isValid = false
      newFormErrors['dateRange'] = "Please select both start and end dates."
    }

    // Ensure start date is not after end date
    if (formFields.startDate && formFields.endDate && new Date(formFields.startDate) > new Date(formFields.endDate)) {
      isValid = false
      newFormErrors['dateRange'] = "Start date cannot be after end date."
    }

    // ensure startDate and endDate are not in the future
    const todayDate = new Date().toISOString().split("T")[0];
    if (formFields.startDate > todayDate || formFields.endDate > todayDate) {
      isValid = false
      newFormErrors['dateRange'] = "Start and end dates cannot be in the future."
    }

    setFormErrors(newFormErrors)
    return isValid
  }

  const fetchData = () => {
    const isValid = validate()
    if (isValid) {
      setShowModal({ "spinner": "Exporting data..." })
      const documentId = `${checklistId}-${Date.now()}`
      const payload = JSON.stringify({
        "action": "document",
        "subAction": "fetchChecklistInfoByDateRange",
        "checklistId": checklistId,
        "documentId": documentId,
        "formFields": formFields
      })
      console.log('🎣 fetching...')
      sendMessageToWebsocket(payload)

      const unsubscribe = subscribe("checklistInfoByDateRangeResponse", data => {
        console.log(data)
        if (data && data.documentId === documentId && data.downloadUrl) {
          setShowModal(null)
          window.location.href = data.downloadUrl
          unsubscribe()
        }
      })
    }
  }


  const changeDateField = (whichDate: string, value: string) => {
    setFormErrors({})
    const newFormFields = { ...formFields }
    if (whichDate === 'startDate') {
      newFormFields.startDate = value
    }
    else if (whichDate === 'endDate') {
      newFormFields.endDate = value
    }
    setFormFields(newFormFields)
  }




  return <div className={`w-full flex flex-col items-center`}>


    <div className={`w-full bg-white flex flex-col items-center`}>
      <div className={`max-w-3xl w-full p-5 flex flex-row gap-4 items-start  justify-between`}>
        <div>
          <h3 className={`font-righteous text-3xl font-brandblue`}>
            {checklistId && tableData && tableData?.Checklists && tableData?.Checklists[checklistId] && tableData?.Checklists[checklistId].ChecklistName ? tableData.Checklists[checklistId].ChecklistName : "Untitled Checklist"}
          </h3>
        </div>
        <Button
          text={'Checklist details'}
          internalLinkUrl={`/checklists/${checklistId}/`}
          variant={'primary'}
          size={'small'}
          fullwidth={false}
        />
      </div>
    </div>



    <div className={`max-w-3xl w-full p-4 flex flex-col gap-4 items-center justify-between`}>
      <p className={``}>Select date range:</p>
      <div className={`flex flex-row gap-4 items-center justify-center`}>
        <div className={`flex flex-row gap-2 items-center`}>
          <label className={``}>From:</label>
          <input
            type="date"
            value={formFields.startDate || ''}
            onChange={(e) => changeDateField('startDate', e.target.value)}
            max={formFields.endDate ? formFields.endDate : today}
            className={`rounded px-2 py-1`}
          />
        </div>
        <div className={`flex flex-row gap-2 items-center`}>
          <label className={``}>To:</label>
          <input
            type="date"
            value={formFields.endDate || ''}
            onChange={(e) => changeDateField('endDate', e.target.value)}
            min={formFields.startDate || ''}
            max={today}
            className={`rounded px-2 py-1`}
          />
        </div>
      </div>

      {formErrors['dateRange'] && <RedAlert size={`small`} alignment='left'>{formErrors['dateRange']}</RedAlert>}


      <div className={``}>

        <label className={`w-full flex flex-row gap-2 justify-start items-center`}>
          <input
            type="checkbox"
            name="includeNotes"
            checked={formFields.includeNotes || false}
            onChange={(e) => setFormFields({ ...formFields, includeNotes: e.target.checked })}
            className={`rounded px-2 py-1`}
          />
          Include answer notes</label>



      </div>

    </div>

    <Button
      text={`Fetch results`}
      variant={'primary'}
      // size={'big'}
      fullwidth={false}
      onClick={fetchData}
    />
  </div >

}
export default ExportChecklistResults